export { AssetDetailsComponent } from "./asset-details.component"
